import Cookies from "js-cookie";

// POPUP
const $popupOpen = $('[data-js~="popup-open"]'),
    $popup = $('[data-js~="popup"]'),
    $popupClose = $('[data-js~="popup-close"]'),
    $popupLinkTransition = $('[data-js~="popup-link-transition"]'),
    $popupGuest = $('[data-js~="popup-guest"]'),
    $popupCloseGuest = $('[data-js~="popup-close-guest"]'),
    $cookiePopup = Cookies.set("cookiePopup");

//TODO remove after begin registration users
setTimeout(function() {
    if (!$cookiePopup) {
        $popupGuest.css("display", "block");
    }

    const $statePopup = $popupGuest.css("display");

    if ($statePopup == "block") {
        $("input").blur();
    }
}, 3000);

var inTwoHours = 1 / 12;

$popupCloseGuest.on("click", function() {
    Cookies.set("cookiePopup", true, {
        expires: inTwoHours
    });
});

$popupOpen.each((i, el) => {
    const $el = $(el),
        inlineSettigns = $el.data("settings"); // {target:"#popup-1"}

    $el.click(e => {
        e.preventDefault();
        $(inlineSettigns.target).show(); // $("#popup-1")
    });
});

$popupLinkTransition.click(function(e) {
    e.stopPropagation();
});

$popupClose.click(function(e) {
    e.preventDefault();

    $popupClose.each((i, el) => {
        if ($(el).is($(e.target))) {
            $popup.hide();
        }
    });
});



// WEBPACK FOOTER //
// ./static/components/popup.js